module.exports = __webpack_public_path__ + "static/media/teacher-anne.3e43776e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/teacher-anne.jpg
 ** module id = 513
 ** module chunks = 0
 **/